module.exports = __webpack_public_path__ + "media/images/footer_page/about/about-3-161144b4ee13fed456c7ccef12ae06b9.svg";